<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Clientes</h1>
          </div>
        </div>
        <div class="level-right" id="topTable">
          <div class="level-item" id="buttonAdd">
            <b-button @click="dialog = true" icon-right="plus" type="is-primary"
              >Adicionar</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Nome" sortable>
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="group.text" label="Grupo" sortable>
            {{ props.row.hasOwnProperty("group") ? props.row.group.text : "" }}
          </b-table-column>
          <b-table-column field="controller_id" label="Controller ID" sortable>
            {{ props.row.controller_id }}
          </b-table-column>

          <b-table-column>
            <b-button
              icon-right="copy"
              size="is-small"
              type="is-info"
              @click="clone(props.row)"
              >Clone</b-button
            >

            <b-button
              icon-right="edit"
              size="is-small"
              type="is-light"
              @click="editItem(props.row)"
              >Editar</b-button
            >

            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
              >Excluir</b-button
            >
          </b-table-column>
        </template>
        <template slot="empty">
          <span>Sem clientes para exibir</span>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>

      <b-modal
        :active.sync="dialog"
        has-modal-card
        trap-focus
        :can-cancel="false"
        aria-role="dialog"
        aria-modal
      >
        <form action>
          <div class="modal-card" style="min-height: 620px; width: auto">
            <header class="modal-card-head">
              <p class="modal-card-title">{{ formTitle }}</p>
            </header>
            <section class="modal-card-body">
              <b-tabs expanded animated type="is-boxed">
                <b-tab-item label="Geral">
                  <b-field grouped group-multiline>
                    <b-field
                      expanded
                      label="Nome do Cliente"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-input
                        type="text"
                        v-model="editedItem.name"
                        required
                      ></b-input>
                    </b-field>
                    <b-field
                      expanded
                      label="ID do Cliente"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-input
                        type="text"
                        v-model="editedItem.controller_id"
                        required
                      ></b-input>
                    </b-field>
                    <b-field
                      label="Grupo"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-select v-model="editedItem.group" expanded>
                        <option
                          v-for="option in [].concat(groups, [
                            { text: 'Novo Grupo' }
                          ])"
                          :value="option"
                          :key="option.text"
                          >{{ option.text }}</option
                        >
                      </b-select>
                    </b-field>
                    <b-field
                      v-if="
                        editedItem.hasOwnProperty('group') &&
                          editedItem.group.text == 'Novo Grupo'
                      "
                    >
                      <b-field
                        label="Pai"
                        label-position="on-border"
                        expanded
                        type="is-primary"
                      >
                        <b-select v-model="newGroup.father">
                          <option
                            v-for="option in groups"
                            :value="option"
                            :key="option.text"
                            >{{ option.text }}</option
                          >
                        </b-select>
                      </b-field>
                      <b-field
                        expanded
                        label="Novo Grupo"
                        label-position="on-border"
                        type="is-primary"
                      >
                        <b-input
                          type="text"
                          v-model="newGroup.text"
                          required
                        ></b-input>
                        <b-button
                          type="is-primary"
                          :disabled="!newGroup.father || !newGroup.text"
                          icon-right="check"
                          @click="saveGroup()"
                        ></b-button>
                      </b-field>
                    </b-field>
                    <b-field>
                      <b-checkbox v-model="editedItem.detectUser"
                        >Detectar Usuário</b-checkbox
                      >
                      <b-checkbox v-model="editedItem.hasNpsFeedback"
                        >Pedir Feedback NPS</b-checkbox
                      >
                    </b-field>
                    <b-field
                      expanded
                      label="URL"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-input type="text" v-model="editedItem.url"></b-input>
                    </b-field>
                  </b-field>
                  <div id="emailField">
                    <b-field
                      label="Email"
                      message="This email is invalid"
                      label-position="on-border"
                    >
                      <b-input type="email" v-model="clientEmail"> </b-input>
                    </b-field>
                  </div>
                </b-tab-item>

                <b-tab-item label="Campos">
                  <b-button
                    @click="addField(editedItem)"
                    icon-left="plus"
                    type="is-primary"
                    inverted
                    >Campo</b-button
                  >
                  <b-table
                    :data="editedItem.fields"
                    ref="table"
                    detailed
                    :show-detail-icon="false"
                    draggable
                    @dragstart="dragstart"
                    @dragover="dragover"
                    @dragleave="dragleave"
                    @drop="dropFields"
                    :sticky-header="true"
                  >
                    <template slot-scope="props">
                      <b-table-column field="name" label="Campo">
                        <b-field>
                          <b-input
                            type="text"
                            v-model="props.row.name"
                            required
                          ></b-input>
                        </b-field>
                      </b-table-column>

                      <b-table-column label="Tipo">
                        <b-field>
                          <b-select
                            v-model="props.row.type"
                            @input="changeFieldType(props.row)"
                          >
                            <option
                              v-for="option in [
                                { value: 'string', text: 'Texto' },
                                { value: 'number', text: 'Número' },
                                { value: 'date', text: 'Data' },
                                { value: 'boolean', text: 'Bool' },
                                { value: 'password', text: 'Senha' },
                                { value: 'list', text: 'Lista' },
                                { value: 'label', text: 'Label' }
                              ]"
                              :value="option.value"
                              :key="option.value"
                              >{{ option.text }}</option
                            >
                          </b-select>
                          <b-button
                            style="width: 3px"
                            @click="editField(props.row)"
                            v-if="props.row.type == 'list'"
                            icon-right="ellipsis-v"
                            type="is-primary"
                            outlined
                          ></b-button>
                        </b-field>
                      </b-table-column>

                      <b-table-column
                        field="i18n[0].label"
                        label="Rótulo (PT)"
                        subheading="PT-BR"
                        sticky
                        cell-class="pt-br"
                        header-class="pt-br"
                      >
                        <b-input
                          expanded
                          type="text"
                          v-model="props.row.i18n[0].label"
                          required
                          @input="setDefault(props.row, 'label')"
                        ></b-input>
                      </b-table-column>

                      <b-table-column label="Grupos">
                        <div class="container">
                          <section>
                            <b-dropdown v-model="props.row.lgpd_group" multiple>
                              <button class="button is-primary" slot="trigger">
                                <span
                                  >{{
                                    props.row.lgpd_group? props.row.lgpd_group.length : 0 + 
                                    " grupos(s)"
                                  }}
                                   </span
                                >
                              </button>

                              <b-dropdown-item
                                v-for="{ id, name } in editedItem.lgpd"
                                :value="id"
                                :key="id"
                              >
                                {{ name }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </section>
                        </div>
                      </b-table-column>

                      <b-table-column
                        centered
                        label="Ativo (PT)"
                        sticky
                        cell-class="pt-br"
                        header-class="pt-br"
                      >
                        <b-checkbox
                          v-model="props.row.i18n[0].is_active"
                          @input="setDefault(props.row, 'is_active')"
                        ></b-checkbox>
                      </b-table-column>

                      <b-table-column
                        centered
                        label="Obrigatório (PT)"
                        sticky
                        cell-class="pt-br"
                        header-class="pt-br"
                      >
                        <b-checkbox
                          v-model="props.row.i18n[0].required"
                          @input="setDefault(props.row, 'required')"
                        ></b-checkbox>
                      </b-table-column>

                      <b-table-column
                        custom-key="Rótulo2"
                        subheading="EN-US"
                        label="Rótulo (EN)"
                        sticky
                        cell-class="en-us"
                        header-class="en-us"
                      >
                        <b-input
                          expanded
                          type="text"
                          v-model="props.row.i18n[1].label"
                        ></b-input>
                      </b-table-column>

                      <b-table-column
                        centered
                        custom-key="Ativo2"
                        label="Ativo (EN)"
                        sticky
                        cell-class="en-us"
                        header-class="en-us"
                      >
                        <b-checkbox
                          v-model="props.row.i18n[1].is_active"
                        ></b-checkbox>
                      </b-table-column>

                      <b-table-column
                        centered
                        custom-key="Obrigatório2"
                        label="Obrigatório (EN)"
                        sticky
                        cell-class="en-us"
                        header-class="en-us"
                      >
                        <b-checkbox
                          v-model="props.row.i18n[1].required"
                        ></b-checkbox>
                      </b-table-column>

                      <b-table-column centered label>
                        <b-button
                          v-if="!props.row.mandatory"
                          style="border: 0px"
                          icon-right="trash"
                          @click="removeField(item)"
                        ></b-button>
                      </b-table-column>
                    </template>

                    <template slot="detail" slot-scope="props">
                      <div v-if="props.row == editedField" class="columns">
                        <div class="column is-4">
                          <b-field label="Valor" label-position="on-border">
                            <b-input
                              expanded
                              type="text"
                              v-model="optionList.value"
                            ></b-input>
                          </b-field>

                          <b-field
                            label="Label PT-BR"
                            label-position="on-border"
                          >
                            <b-input
                              expanded
                              type="text"
                              v-model="optionList.label_pt_br"
                            ></b-input>
                          </b-field>

                          <b-field
                            label="Label EN-US"
                            label-position="on-border"
                          >
                            <b-input
                              expanded
                              type="text"
                              v-model="optionList.label_en_us"
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-1">
                          <b-button
                            type="is-primary"
                            icon-right="plus"
                            outlined
                            @click="addFieldOption()"
                          ></b-button>
                        </div>
                        <div class="column is-7">
                          <b-field expanded>
                            <b-table
                              v-if="props.row == editedField"
                              expanded
                              :data="editedField.options"
                            >
                              <template slot-scope="props">
                                <b-table-column>{{
                                  props.row.value
                                }}</b-table-column>

                                <b-table-column>{{
                                  editedField.i18n[0].options[props.index].label
                                }}</b-table-column>

                                <b-table-column>{{
                                  editedField.i18n[1].options[props.index].label
                                }}</b-table-column>

                                <b-table-column>
                                  <b-button
                                    icon-right="trash"
                                    @click="removeFieldOption(props.index)"
                                    style="border: 0px"
                                  ></b-button>
                                </b-table-column>
                              </template>
                            </b-table>
                          </b-field>
                        </div>
                      </div>
                    </template>

                    <template slot="empty">
                      <section class="section">
                        <div class="content has-text-grey has-text-centered">
                          <p>
                            <b-icon
                              icon="emoticon-sad"
                              size="is-large"
                            ></b-icon>
                          </p>
                          <p>Tabela vazia.</p>
                        </div>
                      </section>
                    </template>
                  </b-table>
                </b-tab-item>

                <b-tab-item label="Aparência">
                  <div class="columns">
                    <div class="column is-three-quarters">
                      <b-field grouped group-multiline>
                        <b-field>
                          <label for="textColor">Cor do Texto</label>
                          <input
                            id="textColor"
                            type="color"
                            v-model="editedItem.textColor"
                            label="Cor do texto"
                            @input="changeColor"
                          />
                        </b-field>
                        <b-field>
                          <label for="color1">Cor principal</label>
                          <input
                            id="color1"
                            type="color"
                            v-model="editedItem.primaryColor"
                            label="Cor Primária"
                            @input="changeColor"
                          />
                        </b-field>
                        <b-field>
                          <label for="color2">Cor secundária</label>
                          <input
                            id="color2"
                            type="color"
                            v-model="editedItem.secondaryColor"
                            label="Cor Primária"
                            @input="changeColor"
                          />
                        </b-field>
                        <b-field>
                          <label for="color3">Cor de fundo</label>
                          <input
                            id="color3"
                            type="color"
                            v-model="editedItem.backgroundColor"
                            label="Cor de fundo"
                            @input="changeColor"
                          />
                        </b-field>
                      </b-field>
                      <b-field>
                        <b-upload
                          v-model="fileObj"
                          v-if="!fileObj"
                          ref="file"
                          drag-drop
                          accept="image/png"
                          @input="onFilePicked(fileObj)"
                        >
                          <section class="section">
                            <div class="content has-text-centered">
                              <p>
                                <b-icon
                                  icon="paperclip"
                                  size="is-medium"
                                ></b-icon>
                              </p>
                              <p>
                                Clique ou arraste sua
                                <strong>logomarca</strong> aqui
                              </p>
                            </div>
                          </section>
                        </b-upload>

                        <div v-else class="columns is-gapless">
                          <div class="column">
                            <b-tag
                              class="is-medium"
                              type="is-primary"
                              closable
                              aria-close-label="Close tag"
                              @close="removeLogo()"
                              >{{ fileObj.name }}</b-tag
                            >
                          </div>
                        </div>
                      </b-field>

                      <b-field>
                        <b-upload
                          v-model="fileObj1"
                          v-if="!fileObj1"
                          ref="fileBG"
                          drag-drop
                          accept="image/png"
                          @input="onFilePickedBG(fileObj1)"
                        >
                          <section class="section">
                            <div class="content has-text-centered">
                              <p>
                                <b-icon
                                  icon="paperclip"
                                  size="is-medium"
                                ></b-icon>
                              </p>
                              <p>
                                Clique ou arraste seu
                                <strong>background</strong> aqui
                              </p>
                            </div>
                          </section>
                        </b-upload>

                        <div v-else class="columns is-gapless">
                          <div class="column">
                            <b-tag
                              class="is-medium"
                              type="is-primary"
                              closable
                              aria-close-label="Close tag"
                              @close="removeBackground()"
                              >{{ fileObj1.name }}</b-tag
                            >
                          </div>
                        </div>
                      </b-field>
                      <b-field grouped>
                        <b-field
                          expanded
                          label="Cabeçalho (Portguês)"
                          label-position="on-border"
                          type="is-primary"
                        >
                          <b-input
                            v-model="editedItem.welcomeHeader_pt_BR"
                          ></b-input>
                        </b-field>
                        <b-field
                          expanded
                          label="Header (English)"
                          label-position="on-border"
                          type="is-primary"
                        >
                          <b-input
                            v-model="editedItem.welcomeHeader_en_US"
                          ></b-input>
                        </b-field>
                      </b-field>
                      <b-field grouped>
                        <b-field
                          expanded
                          label="Rodapé (Português)"
                          label-position="on-border"
                          type="is-primary"
                        >
                          <b-input
                            v-model="editedItem.welcomeFooter_pt_BR"
                          ></b-input>
                        </b-field>
                        <b-field
                          expanded
                          label="Footer (English)"
                          label-position="on-border"
                          type="is-primary"
                        >
                          <b-input
                            v-model="editedItem.welcomeFooter_en_US"
                          ></b-input>
                        </b-field>
                      </b-field>
                    </div>

                    <div class="column is-one-quarter">
                      <div
                        class="mini-captive"
                        :style="
                          'background:url(' +
                            editedItem.bg_base64 +
                            ') no-repeat; background-size: cover;' +
                            'background-color:' +
                            editedItem.backgroundColor
                        "
                      >
                        <div>
                          <img
                            :src="
                              'data:image/png;base64,' + editedItem.logo_base64
                            "
                            style="max-height: 88px; max-width: 88px"
                            v-if="editedItem.logo_base64"
                          />
                          <div v-else class="no-image">Sem Logomarca</div>
                        </div>

                        <div
                          :style="'margin:2px; color: ' + editedItem.textColor"
                        >
                          {{ editedItem.welcomeHeader_pt_BR }}
                        </div>
                        <div
                          cente
                          style="background-color:#bcbaba;width:120px;height:80px;margin-left:22%;"
                        >
                          <b-icon
                            icon="list"
                            size="is-large"
                            style="margin:21px"
                          ></b-icon>
                        </div>
                        <div style="margin-top:18px">
                          <b-button
                            :style="
                              'background-color:' +
                                editedItem.primaryColor +
                                ';' +
                                'color:' +
                                editedItem.secondaryColor
                            "
                            >Button</b-button
                          >
                        </div>

                        <div
                          :style="'margin:2px; color: ' + editedItem.textColor"
                        >
                          {{ editedItem.welcomeFooter_pt_BR }}
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </b-tab-item>

                <b-tab-item label="Autenticação">
                  <b-field grouped group-multiline>
                    <b-field
                      label="Método"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-select v-model="authItem.method">
                        <option
                          v-for="option in ['GET', 'POST', 'PATCH', 'PUT']"
                          :value="option"
                          :key="option"
                          >{{ option }}</option
                        >
                      </b-select>
                    </b-field>

                    <b-field
                      label="URL"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="authItem.url"></b-input>
                    </b-field>
                    <b-field
                      label="Condição"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="authItem.condition"></b-input>
                    </b-field>

                    <b-field
                      label="Tipo"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-select v-model="authItem.bodyType">
                        <option
                          v-for="option in [
                            { text: 'application/json', value: 'json' },
                            { text: 'Texto', value: 'text' }
                          ]"
                          :value="option.value"
                          :key="option.value"
                          >{{ option.text }}</option
                        >
                      </b-select>
                    </b-field>

                    <b-button
                      type="is-primary"
                      inverted
                      icon-left="plus"
                      @click="addAuthApiItem()"
                      >API</b-button
                    >
                  </b-field>
                  <b-field grouped group-multiline></b-field>

                  <b-field grouped group-multiline>
                    <b-field
                      label="Body"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input
                        placeholder="Body"
                        type="textarea"
                        v-model="authItem.body"
                      ></b-input>
                    </b-field>

                    <b-field
                      label="Header"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input
                        placeholder="Header"
                        type="textarea"
                        v-model="authItem.header"
                      ></b-input>
                    </b-field>
                  </b-field>
                  <b-field grouped group-multiline></b-field>
                  <b-field label="Resposta">
                    <b-field
                      expanded
                      grouped
                      group-multiline
                      :horizontal="false"
                    >
                      <b-field
                        label="Campo de Retorno"
                        label-position="on-border"
                        type="is-primary"
                      >
                        <b-input
                          v-model="authItem.responseField"
                          expanded
                        ></b-input>
                      </b-field>
                      <b-field
                        label="Tipo"
                        label-position="on-border"
                        type="is-primary"
                      >
                        <b-select v-model="authItem.responseType">
                          <option
                            v-for="option in ['Boolean', 'String', 'Number']"
                            :value="option"
                            :key="option"
                            >{{ option }}</option
                          >
                        </b-select>
                      </b-field>
                      <b-field
                        label="Valor de OK"
                        label-position="on-border"
                        type="is-primary"
                      >
                        <b-input v-model="authItem.okValue"></b-input>
                      </b-field>
                    </b-field>
                  </b-field>
                  <b-field
                    v-if="editedItem.authApi.length > 0"
                    type="is-primary"
                  >
                    <b-table
                      :data="editedItem.authApi"
                      draggable
                      @dragstart="dragstart"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="dropAuth"
                    >
                      <template slot-scope="props">
                        <b-table-column label="Order" field="order" sortable>{{
                          props.row.order
                        }}</b-table-column>
                        <b-table-column
                          label="Method"
                          field="method"
                          sortable
                          >{{ props.row.method }}</b-table-column
                        >
                        <b-table-column label="URL" field="url" sortable>{{
                          props.row.url
                        }}</b-table-column>
                        <b-table-column centered label="Actions">
                          <b-button
                            icon-right="pen"
                            @click="editAuthApiItem(props.row)"
                            style="border: 0px"
                          ></b-button>
                          <b-button
                            icon-right="trash"
                            @click="removeAuthApiItem(props.row)"
                            style="border: 0px"
                          ></b-button>
                        </b-table-column>
                      </template>
                    </b-table>
                  </b-field>
                </b-tab-item>

                <b-tab-item label="Exportação">
                  <b-field grouped group-multiline>
                    <b-field
                      label="Método"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-select v-model="externalApiItem['method']">
                        <option
                          v-for="option in ['GET', 'POST', 'PATCH', 'PUT']"
                          :value="option"
                          :key="option"
                          >{{ option }}</option
                        >
                      </b-select>
                    </b-field>

                    <b-field
                      label="URL"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input
                        v-model="externalApiItem['url']"
                        expanded
                      ></b-input>
                    </b-field>

                    <b-field
                      label="Condição"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input
                        v-model="externalApiItem['condition']"
                        expanded
                      ></b-input>
                    </b-field>

                    <b-field
                      label="Tipo"
                      label-position="on-border"
                      type="is-primary"
                    >
                      <b-select v-model="externalApiItem['bodyType']">
                        <option
                          v-for="option in [
                            { text: 'application/json', value: 'json' },
                            { text: 'Texto', value: 'text' }
                          ]"
                          :value="option.value"
                          :key="option.value"
                          >{{ option.text }}</option
                        >
                      </b-select>
                    </b-field>
                    <b-button
                      type="is-primary"
                      inverted
                      icon-left="plus"
                      @click="addExternalApiItem(externalApiItem)"
                      >API</b-button
                    >
                  </b-field>

                  <b-field grouped group-multiline>
                    <b-field></b-field>
                  </b-field>

                  <b-field grouped group-multiline>
                    <b-field
                      label="Body"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input
                        placeholder="Body"
                        type="textarea"
                        v-model="externalApiItem['body']"
                      ></b-input>
                    </b-field>
                    <b-field
                      label="Header"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input
                        placeholder="Header"
                        type="textarea"
                        v-model="externalApiItem['header']"
                      ></b-input>
                    </b-field>
                    <b-field>
                      <b-checkbox
                        type="is-primary"
                        v-model="externalApiItem['is_active']"
                        >Ativo</b-checkbox
                      >
                    </b-field>
                  </b-field>

                  <b-field
                    v-if="editedItem.externalApi.length > 0"
                    type="is-primary"
                  >
                    <b-table
                      :data="editedItem.externalApi"
                      detail-key="order"
                      draggable
                      @dragstart="dragstart"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="dropExport"
                    >
                      <template slot-scope="props">
                        <b-table-column label="Order" field="order" sortable>{{
                          props.row.order
                        }}</b-table-column>
                        <b-table-column
                          label="Method"
                          field="method"
                          sortable
                          >{{ props.row.method }}</b-table-column
                        >
                        <b-table-column label="URL" field="url" sortable>{{
                          props.row.url
                        }}</b-table-column>
                        <b-table-column centered label="Status">{{
                          props.row.is_active ||
                          !props.row.hasOwnProperty("is_active")
                            ? "Ativo"
                            : "Inativo"
                        }}</b-table-column>
                        <b-table-column centered label="Actions">
                          <b-button
                            icon-right="pen"
                            @click="editExternalApiItem(props.row)"
                            style="border: 0px"
                          ></b-button>
                          <b-button
                            icon-right="trash"
                            @click="removeExternalApiItem(props.row)"
                            style="border: 0px"
                          ></b-button>
                        </b-table-column>
                      </template>
                    </b-table>
                  </b-field>
                </b-tab-item>

                <b-tab-item label="Termos de Uso">
                  <b-field label="PT-BR" type="is-primary">
                    <b-input
                      v-on:change="lgpd_changes = true"
                      placeholder="Termos de Uso"
                      type="textarea"
                      v-model="editedItem.termsOfUse"
                    ></b-input>
                  </b-field>
                  <b-field label="EN-US" type="is-primary">
                    <b-input
                      placeholder="Termos de Uso"
                      type="textarea"
                      v-model="editedItem.termsOfUseEnglish"
                    ></b-input>
                  </b-field>
                </b-tab-item>
                <b-tab-item label="Termos de Consetimento">
                  <b-field label="PT-BR" type="is-primary">
                    <b-input
                      v-on:change="lgpd_changes = true"
                      placeholder="Termos de Consetimento"
                      type="textarea"
                      v-model="editedItem['termsOfConsent']"
                    ></b-input>
                  </b-field>
                  <b-field label="EN-US" type="is-primary">
                    <b-input
                      placeholder="Termos de Consetimento"
                      type="textarea"
                      v-model="editedItem['termsOfConsentEnglish']"
                    ></b-input>
                  </b-field>

                  <b-field>
                    <b-input
                      v-model="externalLgpdGroup['name']"
                      placeholder="nome"
                    />
                    <b-input
                      v-model="externalLgpdGroup['text']"
                      placeholder="alguma coisa"
                    />
                    <b-checkbox v-model="externalLgpdGroup['active']"
                      >Ativo</b-checkbox
                    >
                    <b-button
                      type="is-primary"
                      inverted
                      icon-left="plus"
                      @click="createNewLgpd()"
                    >
                      GROUP
                    </b-button>
                  </b-field>
                  <b-field type="is-primary">
                    <b-table :data="editedItem.lgpd">
                      <template slot-scope="props">
                        <b-table-column label="nome" field="name">{{
                          props.row.name
                        }}</b-table-column>
                        <b-table-column label="texto" field="text">{{
                          props.row.text
                        }}</b-table-column>
                        <b-table-column centered label="Actions">
                          <b-button
                            icon-right="pen"
                            @click="editLgpdGroup(props.row)"
                            style="border: 0px"
                          />
                          <b-button
                            icon-right="trash"
                            @click="removeLgpdGroup(props.row)"
                            style="border: 0px"
                          />
                        </b-table-column>
                      </template>
                    </b-table>
                  </b-field>
                </b-tab-item>

                <b-tab-item label="Login Social">
                  <b-field>
                    <b-checkbox
                      type="is-primary"
                      v-model="editedItem.withFacebook"
                      >Facebook</b-checkbox
                    >
                  </b-field>
                </b-tab-item>

                <b-tab-item label="Info da Rede">
                  <b-field grouped group-multiline>
                    <b-field
                      grouped
                      label="Prefixo do Rádios"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="editedItem.radio_prefix"></b-input>
                    </b-field>

                    <b-field
                      grouped
                      label="Zona do Captive"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="editedItem.zone"></b-input>
                    </b-field>
                    <b-field
                      grouped
                      label="Campo de Auth User"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-select expanded v-model="editedItem.auth_user_field">
                        <option
                          v-for="option in activeFields"
                          :value="option.name"
                          :key="option.name"
                          >{{ option.label }}</option
                        >
                      </b-select>
                    </b-field>

                    <b-field
                      grouped
                      label="ID Vagalox"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="editedItem.idVagalox"></b-input>
                    </b-field>
                    <b-field grouped>
                      <b-checkbox v-model="editedItem.activeMap"
                        >Notificações Ativas</b-checkbox
                      >
                    </b-field>
                    <b-field grouped>
                      <b-checkbox v-model="editedItem.sendEmail"
                        >Email AP Offline</b-checkbox
                      >
                    </b-field>
                  </b-field>
                  <br />
                  <b-field grouped group-multiline>
                    <b-field grouped>
                      <b-checkbox v-model="editedItem.link">Link</b-checkbox>
                    </b-field>
                    <b-field
                      grouped
                      label="ID Swarm"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="editedItem.idSwarm"></b-input>
                    </b-field>

                    <b-field
                      grouped
                      label="Areas"
                      label-position="on-border"
                      type="is-primary"
                      expanded
                    >
                      <b-input v-model="editedItem.clientAreas"></b-input>
                    </b-field>
                  </b-field>
                  <b-button
                    v-if="editedItem.link"
                    @click="addFieldLink(editedItem)"
                    icon-left="plus"
                    type="is-primary"
                    inverted
                    >Novo Link</b-button
                  >
                  <b-table
                    v-if="editedItem.link"
                    :data="editedItem.link_config"
                    ref="table"
                    detailed
                    :show-detail-icon="false"
                    draggable
                    @dragstart="dragstart"
                    @dragover="dragover"
                    @dragleave="dragleave"
                    @drop="dropFields"
                    :sticky-header="true"
                  >
                    <template slot-scope="props">
                      <b-table-column field="name" label="Interface">
                        <b-field>
                          <b-input
                            type="text"
                            v-model="props.row.link_interface"
                            required
                          ></b-input>
                        </b-field>
                      </b-table-column>
                      <b-table-column field="name" label="Label">
                        <b-field>
                          <b-input
                            type="text"
                            v-model="props.row.link_label"
                            required
                          ></b-input>
                        </b-field>
                      </b-table-column>

                      <b-table-column
                        field="i18n[0].label"
                        label="Limite Latência"
                        sticky
                        cell-class="pt-br"
                        header-class="pt-br"
                      >
                        <b-input
                          expanded
                          type="text"
                          v-model="props.row.link_limit_latency"
                          required
                          @input="setDefault(props.row, 'label')"
                        ></b-input>
                      </b-table-column>
                      <b-table-column
                        field="i18n[0].label"
                        label="Limite Rede"
                        sticky
                        cell-class="pt-br"
                        header-class="pt-br"
                      >
                        <b-input
                          expanded
                          type="text"
                          v-model="props.row.link_limit_download"
                          required
                          @input="setDefault(props.row, 'label')"
                        ></b-input>
                      </b-table-column>

                      <b-table-column
                        centered
                        label="Ativo (PT)"
                        sticky
                        cell-class="pt-br"
                        header-class="pt-br"
                      >
                        <b-checkbox
                          v-model="props.row.ativo"
                          @input="setDefault(props.row, 'is_active')"
                        ></b-checkbox>
                      </b-table-column>
                      <b-table-column centered label>
                        <b-button
                          v-if="!props.row.mandatory"
                          style="border: 0px"
                          icon-right="trash"
                          @click="removeFieldLink(item)"
                        ></b-button>
                      </b-table-column>
                    </template>

                    <template slot="detail" slot-scope="props">
                      <div v-if="props.row == editedField" class="columns">
                        <div class="column is-4">
                          <b-field label="Valor" label-position="on-border">
                            <b-input
                              expanded
                              type="text"
                              v-model="optionList.value"
                            ></b-input>
                          </b-field>

                          <b-field
                            label="Label PT-BR"
                            label-position="on-border"
                          >
                            <b-input
                              expanded
                              type="text"
                              v-model="optionList.label_pt_br"
                            ></b-input>
                          </b-field>

                          <b-field
                            label="Label EN-US"
                            label-position="on-border"
                          >
                            <b-input
                              expanded
                              type="text"
                              v-model="optionList.label_en_us"
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-1">
                          <b-button
                            type="is-primary"
                            icon-right="plus"
                            outlined
                            @click="addFieldOption()"
                          ></b-button>
                        </div>
                        <div class="column is-7">
                          <b-field expanded>
                            <b-table
                              v-if="props.row == editedField"
                              expanded
                              :data="editedField.options"
                            >
                              <template slot-scope="props">
                                <b-table-column>{{
                                  props.row.value
                                }}</b-table-column>

                                <b-table-column>{{
                                  editedField.i18n[0].options[props.index].label
                                }}</b-table-column>

                                <b-table-column>{{
                                  editedField.i18n[1].options[props.index].label
                                }}</b-table-column>

                                <b-table-column>
                                  <b-button
                                    icon-right="trash"
                                    @click="removeFieldOption(props.index)"
                                    style="border: 0px"
                                  ></b-button>
                                </b-table-column>
                              </template>
                            </b-table>
                          </b-field>
                        </div>
                      </div>
                    </template>
                  </b-table>
                </b-tab-item>
              </b-tabs>
            </section>

            <footer class="modal-card-foot">
              <b-button @click="close">Cancelar</b-button>
              <b-button type="is-primary" @click.native="save">Salvar</b-button>
            </footer>
          </div>
        </form>
      </b-modal>
    </div>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapGetters, Store } from "vuex";
import { v4 as uuid } from "uuid";
import store from "@/store";
import Sortable from "vue-drag-sortable";
import { mapActions } from "vuex";
const ws = new Webservices();

export default {
  name: "Clientes",
  components: { Sortable },
  data: () => ({
    externalLgpdGroup: {
      id: "teste",
      name: "teste",
      text: "teste",
      active: true
    },
    clientEmail: "",
    lgpd_changes: false,
    perPage: 10,
    draggingRow: null,
    draggingRowIndex: null,
    fileObj: undefined,
    fileObj1: undefined,
    editedField: null,
    dragObject: {},
    dialogField: false,
    optionList: { value: "", label_pt_br: "", label_en_us: "" },
    dialogProgress: false,
    active: "tab-0",
    imageUploaded: false,
    authItem: { order: -1 },
    externalApiItem: { order: -1, is_active: true },
    dateSD: "",
    dateED: "",
    modalSD: false,
    groups: [],
    modalED: false,
    loading3: false,
    modal: false,
    imageName: "",
    imageUrl: "",
    imageFile: "",
    imageNameBG: "",
    imageUrlBG: "",
    imageFileBG: "",
    dialog: false,
    model_videos: {
      properties: {
        client_id: { type: "string" },
        author: { type: "string" },
        name: { type: "string" },
        bucket: { type: "string" },
        timeCreated: { type: "date" },
        size: { type: "number" },
        mediaLink: { type: "string" },
        start_date: { type: "date" },
        end_date: { type: "date" },
        is_active: { type: "boolean" }
      }
    },
    headers: [
      {
        text: "Nome",
        value: "name"
      },
      { text: "Grupo", value: "group.text" },
      { text: "ID", value: "controller_id" },

      { text: "Actions", align: "center", sortable: false }
    ],
    desserts: [],
    externalApiHeaders: [
      {
        text: "Order",
        value: "order",
        align: "right"
      },
      { text: "method", value: "method", align: "left" },
      { text: "url", value: "url", align: "left" },
      { text: "Actions", align: "center", value: "actions", sortable: false }
    ],
    camposItems: [],
    editedIndex: -1,
    newGroup: {
      text: "",
      father: undefined,
      father_id: undefined
    },
    editedItem: {
      clientAreas: 0,
      hasNpsFeedback: false,
      radio_prefix: "",
      welcomeHeader_pt_BR: "",
      welcomeFooter_pt_BR: "",
      welcomeHeader_en_US: "",
      welcomeFooter_en_US: "",
      zone: "captive",
      termsOfUse: "",
      termsOfConsent: "",
      detectUser: true,
      activeMap: false,
      sendEmail: false,
      idVagalox: "",
      idSwarm: "",
      link: false,
      id_swarm: "",
      link_config: [
        {
          link_limit_latency: 500,
          ativo: true,
          link_interface: "igb0",
          link_label: "Nome",
          link_limit_download: 10000
        }
      ],
      client_id: "Elcoma",
      author: "Elcoma Networks",
      primaryColor: "#0000ff",
      secondaryColor: "#ff0000",
      name: "",
      bucket: "",
      timeCreated: undefined,
      size: 0,
      mediaLink: undefined,
      is_active: true,
      bg_base64: null,
      logo_base64: null,
      group: {},
      auth: { type: "default" },
      export: { type: "default" },
      externalApi: [],
      authApi: [],
      withFacebook: true,
      auth_user_field: "name",
      fields: [
        {
          name: "name",
          label: "Nome",
          type: "string",
          is_active: true,
          mandatory: true,
          required: true,
          i18n: [
            {
              lang: "pt-BR",
              label: "Nome",
              is_active: true,
              required: true
            },
            {
              lang: "en-US",
              label: "Name",
              is_active: true,
              required: true
            }
          ]
        },
        {
          name: "cpf",
          label: "CPF",
          type: "string",
          is_active: false,
          mandatory: false,
          required: false,
          i18n: [
            {
              lang: "pt-BR",
              label: "CPF",
              is_active: false,
              required: false
            },
            {
              lang: "en-US",
              label: "CPF",
              is_active: false,
              required: false
            }
          ]
        },
        {
          name: "email",
          label: "E-mail",
          type: "string",
          is_active: false,
          mandatory: false,
          required: false,
          i18n: [
            {
              lang: "pt-BR",
              label: "E-mail",
              is_active: false,
              required: false
            },
            {
              lang: "en-US",
              label: "E-mail",
              is_active: false,
              required: false
            }
          ]
        },
        {
          name: "birth_date",
          label: "Data de Nascimento",
          type: "date",
          is_active: true,
          mandatory: false,
          required: false,
          i18n: [
            {
              lang: "pt-BR",
              label: "Data de Nascimento",
              is_active: true,
              required: false
            },
            {
              lang: "en-US",
              label: "Birth Date",
              is_active: true,
              required: false
            }
          ]
        },
        {
          name: "gender",
          label: "Sexo",
          type: "list",
          is_active: true,
          mandatory: false,
          required: false,
          options: [
            { label: "Masculino", value: "m" },
            { label: "Feminino", value: "f" },
            { label: "Não Informado", value: " " }
          ],
          i18n: [
            {
              lang: "pt-BR",
              label: "Sexo",
              is_active: true,
              required: false,
              options: [
                { label: "Masculino", value: "m" },
                { label: "Feminino", value: "f" },
                { label: "Não Informado", value: " " }
              ]
            },
            {
              lang: "en-US",
              label: "Gender",
              is_active: true,
              required: false,
              options: [
                { label: "Male", value: "m" },
                { label: "Female", value: "f" },
                { label: "Do not identify", value: " " }
              ]
            }
          ]
        }
      ]
    },
    defaultItem: {
      hasNpsFeedback: false,
      welcomeHeader_pt_BR: "",
      welcomeFooter_pt_BR: "",
      welcomeHeader_en_US: "",
      welcomeFooter_en_US: "",
      radio_prefix: "",
      zone: "captive",
      termsOfUse: "",
      termsOfConsent: "",
      detectUser: true,
      activeMap: false,
      sendEmail: false,
      idVagalox: "",
      idSwarm: "",
      link: false,
      id_swarm: "",
      link_config: [
        {
          link_limit_latency: 500,
          ativo: true,
          link_interface: "igb0",
          link_label: "Nome",
          link_limit_download: 10000
        }
      ],
      client_id: "elcoma",
      author: "Elcoma Networks",
      primaryColor: "#0000ff",
      secondaryColor: "#ff0000",
      name: "",
      bucket: "",
      timeCreated: undefined,
      size: 0,
      mediaLink: undefined,
      is_active: true,
      bg_base64: null,
      logo_base64: null,
      externalApi: [],
      group: {},
      authApi: [],
      withFacebook: true,
      auth_user_field: "name",
      fields: [
        {
          name: "name",
          label: "Nome",
          type: "string",
          is_active: true,
          mandatory: true,
          required: true,
          i18n: [
            {
              lang: "pt-BR",
              label: "Nome",
              is_active: true,
              required: true
            },
            {
              lang: "en-US",
              label: "Name",
              is_active: true,
              required: true
            }
          ]
        },
        {
          name: "cpf",
          label: "CPF",
          type: "string",
          is_active: false,
          mandatory: false,
          required: false,
          i18n: [
            {
              lang: "pt-BR",
              label: "CPF",
              is_active: false,
              required: false
            },
            {
              lang: "en-US",
              label: "CPF",
              is_active: false,
              required: false
            }
          ]
        },
        {
          name: "email",
          label: "E-mail",
          type: "string",
          is_active: false,
          mandatory: false,
          required: false,
          i18n: [
            {
              lang: "pt-BR",
              label: "E-mail",
              is_active: false,
              required: false
            },
            {
              lang: "en-US",
              label: "E-mail",
              is_active: false,
              required: false
            }
          ]
        },
        {
          name: "birth_date",
          label: "Data de Nascimento",
          type: "date",
          is_active: true,
          mandatory: false,
          required: false,
          i18n: [
            {
              lang: "pt-BR",
              label: "Data de Nascimento",
              is_active: true,
              required: false
            },
            {
              lang: "en-US",
              label: "Birth Date",
              is_active: true,
              required: false
            }
          ]
        },
        {
          name: "gender",
          label: "Sexo",
          type: "list",
          is_active: true,
          mandatory: false,
          required: false,
          options: [
            { label: "Masculino", value: "m" },
            { label: "Feminino", value: "f" },
            { label: "Não Informado", value: " " }
          ],
          i18n: [
            {
              lang: "pt-BR",
              label: "Sexo",
              is_active: true,
              required: false,
              options: [
                { label: "Masculino", value: "m" },
                { label: "Feminino", value: "f" },
                { label: "Não Informado", value: " " }
              ]
            },
            {
              lang: "en-US",
              label: "Gender",
              is_active: true,
              required: false,
              options: [
                { label: "Male", value: "m" },
                { label: "Female", value: "f" },
                { label: "Do not identify", value: " " }
              ]
            }
          ]
        }
      ],
      termsOfUseBackup: "",
      termsOfConsentBackup: "",
      auth: { type: "default" },
      export: { type: "default" },
      emailSetting: {
        clientID: "",
        senderEmail: "",
        senderPassword: "mocado"
      }
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Novo Cliente" : "Editar";
    },
    activeFields() {
      return this.editedItem.fields.filter(
        el =>
          el.is_active &&
          (el.type == "string" || el.type == "number" || el.type == "list")
      );
    },
    ...mapGetters(["isDark", "getToken"])
  },

  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    ws.setToken(this.getToken);

    ws.getClients().then(response => {
      this.desserts = response.data;
    });
    ws.getGroups().then(response => {
      this.groups = response.data;
    });
  },

  watch: {
    dialog(val) {
      if (val) {
        store.state.currentModal = "addOrEditClientModal";
      } else {
        store.state.currentModal = undefined;
        this.close();
      }
    },
    getID() {
      this.emailSetting = {
        clientID: "",
        senderEmail: "",
        senderPassowrd: "mocado"
      };
      this.getClientSettingsEmail();
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    ...mapActions(["logout"]),
    initialize() {},

    dragstart(payload) {
      this.draggingRow = payload.row;
      this.draggingRowIndex = payload.index;
      payload.event.dataTransfer.effectAllowed = "copy";
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = "copy";
      payload.event.target.closest("tr").classList.add("is-selected");
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest("tr").classList.remove("is-selected");
      payload.event.preventDefault();
    },
    dropFields(payload) {
      payload.event.target.closest("tr").classList.remove("is-selected");
      const droppedOnRowIndex = payload.index;
      this.rearrange(
        this.editedItem.fields,
        this.draggingRowIndex,
        droppedOnRowIndex
      );
    },
    dropAuth(payload) {
      payload.event.target.closest("tr").classList.remove("is-selected");
      const droppedOnRowIndex = payload.index;
      this.rearrange(
        this.editedItem.authApi,
        this.draggingRowIndex,
        droppedOnRowIndex
      );
    },
    dropExport(payload) {
      payload.event.target.closest("tr").classList.remove("is-selected");
      const droppedOnRowIndex = payload.index;
      this.rearrange(
        this.editedItem.externalApi,
        this.draggingRowIndex,
        droppedOnRowIndex
      );
    },
    // sortEnd(e, list) {
    //   const { oldIndex, newIndex } = e;
    //   this.rearrange(list, oldIndex, newIndex);
    // },
    sortEndExtApi(e, list) {
      const { oldIndex, newIndex } = e;
      this.rearrangeExtApi(list, oldIndex, newIndex);
    },
    rearrange(array, oldIndex, newIndex) {
      if (oldIndex > newIndex) {
        array.splice(newIndex, 0, array[oldIndex]);
        array.splice(oldIndex + 1, 1);
      } else {
        array.splice(newIndex + 1, 0, array[oldIndex]);
        array.splice(oldIndex, 1);
      }
    },
    rearrangeExtApi(array, oldIndex, newIndex) {
      if (oldIndex > newIndex) {
        array.splice(newIndex, 0, array[oldIndex]);
        array.splice(oldIndex + 1, 1);
      } else {
        array.splice(newIndex + 1, 0, array[oldIndex]);
        array.splice(oldIndex, 1);
      }

      array.forEach((el, index) => {
        el["order"] = index + 1;
      });
    },
    createNewLgpd() {
      this.lgpd_changes = true;
      this.editedItem.lgpd.push({
        id: uuid(),
        name: "Novo grupo",
        text: "Novo texto",
        active: true
      });
    },
    saveGroup() {
      var fatherText = this.newGroup.father.text;
      this.newGroup.father_id = this.newGroup.father.id;
      this.newGroup.father = fatherText;

      ws.postGroup(this.newGroup).then(response => {
        this.editedItem.group = response.data;
        this.groups.push(response.data);
      });
    },

    addField(item) {
      item.fields.push({
        name: "",
        label: "",
        type: "",
        is_active: false,
        mandatory: false,
        required: false,
        i18n: [
          {
            lang: "pt-BR",
            label: "",
            is_active: false,
            required: false
          },
          {
            lang: "en-US",
            label: "",
            is_active: false,
            required: false
          }
        ]
      });
    },
    addFieldLink(item) {
      item.link_config.push({
        link_limit_latency: 500,
        link_interface: "",
        link_label: "",
        link_limit_download: 10000,
        ativo: true
      });
    },

    editItem(item) {
      ws.getClientById(item.id)
        .then(response => {
          this.editedIndex = this.desserts.indexOf(item);
          Object.assign(this.editedItem, response.data);
          if (!this.editedItem.clientAreas) {
            this.editedItem["clientAreas"] = 0;
          }
          this.termsOfUseBackup = this.editedItem.termsOfUse;
          this.termsOfConsentBackup = this.editedItem.termsOfConsent;
          if (!this.editedItem.hasOwnProperty("hasNpsFeedback")) {
            this.editedItem["hasNpsFeedback"] = false;
          }

          if (this.editedItem.hasOwnProperty("fields") == false) {
            this.editedItem.fields = [];
          }
          if (this.editedItem.hasOwnProperty("group") == false) {
            this.editedItem["group"] = {};
          }
          if (this.editedItem.hasOwnProperty("lgpd") == false) {
            this.editedItem["lgpd"] = [
              {
                id: uuid(),
                name: "Contato",
                text: "informações de contato",
                active: true
              },
              {
                id: uuid(),
                name: "Pessoal",
                text: "dados pessoais",
                active: true
              }
            ];
          }

          this.editedItem.fields.forEach(field => {
            if (!field.hasOwnProperty("i18n")) {
              field["i18n"] = [
                {
                  lang: "pt-BR",
                  label: "",
                  is_active: false,
                  required: false
                },
                {
                  lang: "en-US",
                  label: "",
                  is_active: false,
                  required: false
                }
              ];

              field.i18n[0].label = field.label;
              field.i18n[0].is_active = field.is_active;
              field.i18n[0].required = field.required;

              if (field.hasOwnProperty("options")) {
                field.i18n[0]["options"] = JSON.parse(
                  JSON.stringify(field.options)
                );
                field.i18n[1]["options"] = JSON.parse(
                  JSON.stringify(field.options)
                );

                field.i18n[1].options.forEach(option => {
                  if (
                    option.label.startsWith("M") ||
                    option.label.startsWith("m")
                  ) {
                    option.label = "Male";
                  } else if (
                    option.label.startsWith("F") ||
                    option.label.startsWith("f")
                  ) {
                    option.label = "Female";
                  }
                });
              }
            }
            if (!field.lgpd_group) {
              field.lgpd_group = [];
            }
          });

          this.dialog = true;
        })
        .catch(err => {
          alert("Erro");
          console.log(err);
        });
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      if (
        confirm(
          "Você tem certeza que deseja remover o cliente '" + item.name + "'?"
        )
      ) {
        this.desserts.splice(index, 1);
        ws.deleteClient(item.id).then(response => {});
      }
    },

    removeField(item) {
      const index = this.editedItem.fields.indexOf(item);
      if (confirm("Você tem certeza que deseja remover esse campo?")) {
        this.editedItem.fields.splice(index, 1);
      }
    },
    removeFieldLink(item) {
      const index = this.editedItem.link_config.indexOf(item);
      if (confirm("Você tem certeza que deseja remover essa configuração?")) {
        this.editedItem.link_config.splice(index, 1);
      }
    },

    close() {
      this.lgpd_changes = false;
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.imageUploaded = false;
      }, 300);
    },

    save() {
      if (!this.editedItem.hasOwnProperty("radio_prefix")) {
        this.editedItem["radio_prefix"] = "";
      }

      if (this.lgpd_changes) {
        this.editedItem["lgpd_time"] = new Date();
      }

      if (this.termsOfUseBackup != this.editedItem.termsOfUse) {
        this.editedItem["termsOfUseTime"] = new Date();
      }

      if ((this.termsOfConsentBackup = this.editedItem.termsOfConsent)) {
        this.editedItem["termsOfConsentTime"] = new Date();
      }
      if (this.editedItem.radio_prefix.length == 0)
        this.editedItem.radio_prefix = this.editedItem.controller_id;

      if (this.editedIndex > -1) {
        ws.editClient(this.editedItem).then(response => {});
      } else {
        this.desserts.push(this.editedItem);
        ws.saveClient(this.editedItem).then(response => {
          this.editedItem.id = response.data.id;
        });
      }
      this.close();
    },
    removeResposta(item) {
      this.editedItem.answers.splice(this.editedItem.answers.indexOf(item), 1);
      this.editedItem.answers = [...this.editedItem.answers];
    },
    pickFile() {
      this.$refs.file.click();
    },
    pickFileBG() {
      this.$refs.fileBG.click();
    },
    saveClient() {},
    onFilePicked(e) {
      if (this.fileObj !== undefined) {
        this.imageName = this.fileObj.name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        //Converting to base64
        const fr = new FileReader();
        fr.readAsDataURL(this.fileObj);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = this.fileObj; // this is an image file that can be sent to server...
        });
        fr.onload = () => {
          this.editedItem.mediaLink = fr.result;
          this.editedItem.logo_base64 = fr.result;
          this.editedItem.logo_base64 = this.editedItem.logo_base64.replace(
            "data:image/png;base64,",
            ""
          );
          this.imageUploaded = true;
        };
      }
    },

    onFilePickedBG(e) {
      if (this.fileObj1 !== undefined) {
        this.imageNameBG = this.fileObj1.name;
        if (this.imageNameBG.lastIndexOf(".") <= 0) {
          return;
        }
        //Converting to base64
        const fr = new FileReader();
        fr.readAsDataURL(this.fileObj1);
        fr.addEventListener("load", () => {
          this.imageUrlBG = fr.result;
          this.imageFileBG = this.fileObj1; // this is an image file that can be sent to server...
        });
        fr.onload = () => {
          this.editedItem.mediaLinkBG = fr.result;
          this.editedItem.bg_base64 = fr.result;
          this.imageUploaded = true;

          this.$forceUpdate();
        };
      }
    },
    //para a data table de autenticacao.
    addAuthApiItem() {
      var order = this.editedItem.authApi.length || 0;

      if (this.authItem.order == -1) {
        this.authItem.order = order + 1;
        this.editedItem.authApi.push(this.authItem);
      }
      this.authItem = {
        order: -1,
        method: undefined,
        url: "",
        body: "",
        header: ""
      };
    },
    removeAuthApiItem(apiItem) {
      this.editedItem.authApi.splice(
        this.editedItem.authApi.indexOf(apiItem),
        1
      );
    },
    editAuthApiItem(apiItem) {
      this.authItem = apiItem;
    },

    addExternalApiItem() {
      var order = this.editedItem.externalApi.length || 0;

      if (this.externalApiItem.order == -1) {
        this.externalApiItem.order = order + 1;
        //aqui ele joga em externalAPI
        this.editedItem.externalApi.push(this.externalApiItem);
      }

      this.externalApiItem = {
        order: -1,
        method: undefined,
        url: "",
        body: "",
        header: "",
        is_active: true
      };
    },
    removeExternalApiItem(apiItem) {
      this.editedItem.externalApi.splice(
        this.editedItem.externalApi.indexOf(apiItem),
        1
      );
    },
    removeLgpdGroup(group) {
      if (!confirm("Tem certeza que deseja excluir esse termo?")) return;

      this.lgpd_changes = true;
      this.editedItem.fields.forEach(field => {
        const index = field.lgpd_group.findIndex(id => id === group.id);
        if (index != -1) {
          field.lgpd_group.splice(index, 1);
        }
      });
      const index = this.editedItem.lgpd.findIndex(g => g.id === group.id);
      this.editedItem.lgpd.splice(index, 1);
    },
    editExternalApiItem(apiItem) {
      this.externalApiItem = apiItem;
    },
    editLgpdGroup(group) {
      this.externalLgpdGroup = group;
      this.lgpd_changes = true;
    },
    selectClient(client) {
      ws.getClientLogo(client.controller_id).then(response => {
        client["logo_Base64"] = response.data.logo_base64;
        store.state.client = client;
      });
    },
    changeFieldType(item) {
      if (item.type == "list") {
        if (!item.hasOwnProperty("options"))
          item["options"] = [
            { label: "Masculino", value: "m" },
            { label: "Feminino", value: "f" },
            { label: "Não Informado", value: "" }
          ];

        if (!item.i18n[0].hasOwnProperty("options"))
          item.i18n[0]["options"] = [
            { label: "Masculino", value: "m" },
            { label: "Feminino", value: "f" },
            { label: "Não Informado", value: "" }
          ];

        if (!item.i18n[1].hasOwnProperty("options"))
          item.i18n[1]["options"] = [
            { label: "Masculino", value: "m" },
            { label: "Feminino", value: "f" },
            { label: "Não Informado", value: "" }
          ];

        this.editedField = item;
        this.dialogField = true;
      } else {
        if (item.hasOwnProperty("options")) delete item["options"];
      }

      this.$forceUpdate();
    },
    setDefault(item, field) {
      item[field] = item.i18n[0][field];
    },
    removeLogo() {
      this.fileObj = undefined;
      this.editedItem.logo_base64 = undefined;
    },
    removeBackground() {
      this.fileObj1 = undefined;
      this.editedItem.bg_base64 = undefined;
    },
    changeColor() {
      this.$forceUpdate();
    },
    clone(portal) {
      if (confirm("Deseja clonar o portal de '" + portal.name + "'")) {
        this.dialogProgress = true;

        ws.getClientById(portal.id)
          .then(response => {
            var newPortal = response.data;
            delete newPortal["id"];
            newPortal.controller_id = "clone-de-" + newPortal.controller_id;
            newPortal.name = "Clone de " + newPortal.name;

            delete newPortal["mediaLink"];

            return ws.saveClient(newPortal);
          })
          .then(saved => {
            var savedPortal = saved.data;

            delete savedPortal["bg_base64"];
            delete savedPortal["logo_base64"];

            this.desserts.push(saved.data);

            this.dialogProgress = false;
          });
      }
    },
    editField(field) {
      this.$refs.table.toggleDetails(field);
      this.editedField = field;
      this.dialogField = true;
    },
    removeFieldOption(index_option) {
      this.editedField.options.splice(index_option, 1);
      this.editedField.i18n[0].options.splice(index_option, 1);
      this.editedField.i18n[1].options.splice(index_option, 1);

      this.$forceUpdate();
    },
    addFieldOption() {
      this.editedField.options.push({
        value: this.optionList.value,
        label: this.optionList.label_pt_br
      });
      this.editedField.i18n[0].options.push({
        value: this.optionList.value,
        label: this.optionList.label_pt_br
      });
      this.editedField.i18n[1].options.push({
        value: this.optionList.value,
        label: this.optionList.label_en_us
      });

      this.$forceUpdate();
    },
    onSubmitSettingsEmail() {
      if (this.editSettingEmail) {
        ws.putEmailSettings(this.emailSettingID, this.emailSetting)
          .then(response => {
            //fazer algo quando a edição tiver sucesso
            this.openModalEmail = false;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.emailSetting.clientID = this.getID;

        ws.postEmailSettings(this.emailSetting)
          .then(response => {
            // fazer algo quando o cadastro tiver sucesso
          })
          .catch(err => {
            console.log(err);
            //fazer algo quando o cadastro falhar
          });
      }
    },
    getClientSettingsEmail() {
      ws.getEmailSettings(this.getID)
        .then(responde => {
          const emailSetting = responde.data;
          const [{ id, ...rest }] = emailSetting;
          this.emailSetting = rest;
          this.emailSettingID = id;
          this.editSettingEmail = true;
        })
        .catch(() => {
          this.editSettingEmail = false;
        });
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
input {
  margin: 0.4rem;
  border: solid thin darkgray;
}

.active-tab {
  background-color: red !important;
}

td.inner {
  padding: 0 5px !important;
  justify-content: center !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  outline-color: blue !important;
}

.inner > * {
  font-size: small;
}

.no-image {
  width: 88px;
  height: 88px;
  border: dotted 2px darkgray;
  margin: auto !important;
}

.mini-captive {
  width: 200px;
  height: 360px;
  border: solid 1px lightgray;
  margin: auto;
}

.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
  min-width: 79vw !important;
}

.list > *.dragging {
  background-color: rgba(230, 230, 2, 0.7);
}
.pt-br {
  /* background-color: rgba(76, 241, 10, 0.3) !important; */
}

.en-us {
  /* background-color: rgba(255, 17, 0, 0.3) !important; */
}
#topTable {
  padding-bottom: 10px;
}

#emailField {
  padding-top: 20px;
}

#buttonAdd {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Clientes.vue